import { createContext } from 'react'

const sellerPayoutContext = createContext()

export default sellerPayoutContext
